import React, {type ReactElement} from 'react';

import {browserHistory} from 'react-router';

interface Props<T> {
  content: any;
  versionAvailable: boolean;
  location: {
    readonly query: {
      readonly hidediff?: string;
    };
  };
  getDiffContent: () => T;
  children: (
    content: T,
    showingDiff: boolean,
    toggleDiff: () => void
  ) => ReactElement;
}
export function GenericDiffer<T>({
  content,
  versionAvailable,
  location,
  getDiffContent,
  children,
}: Props<T>) {
  const isDiffEnabled = React.useMemo(
    () => location.query.hidediff !== '1',
    [location.query.hidediff]
  );

  function toggleDiff() {
    browserHistory.replace({
      ...location,
      query: {
        ...location.query,
        hidediff: isDiffEnabled ? 1 : undefined,
      },
    });
  }

  return versionAvailable && isDiffEnabled
    ? children(getDiffContent(), true, toggleDiff)
    : children(content, false, toggleDiff);
}
